import { render } from "./yi-header.vue?vue&type=template&id=552d99ba&scoped=true"
import script from "./yi-header.vue?vue&type=script&lang=js"
export * from "./yi-header.vue?vue&type=script&lang=js"

import "./yi-header.vue?vue&type=style&index=0&id=552d99ba&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552d99ba"]])

export default __exports__